module.exports = __webpack_public_path__ + "static/img/bg-map.43d3a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-map.png
// module id = dRMa
// module chunks = 0